// import Button from "components/Button/Button";
import styled from "styled-components";

export const ArrayFieldEntries = styled.div`
    
`;